/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, MouseEvent, useContext, useEffect, useState } from "react";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { DeleteCaseDraftAPIRes, DraftItemProps } from "./types";
import { CaseContext } from "src/context/caseContext";
import DeletionConfirmationModal from "./deletionConfirmModal";
import { format, isValid, parse } from "date-fns";




const CaseDraftItem: FC<DraftItemProps> = ({ draft, getCaseDraftListing, populateCaseDraftInForm, reset }): JSX.Element => {
  const [showDeletionConfirmationModal, setDeletionConfirmationVisibility] = useState<boolean>(false)

  const { showToast } = useContext(ToastContext)
  const { draftCaseId, updateDraftCaseId } = useContext(CaseContext)




  const { data: deleteCaseDraftRes, mutate: deleteCaseDraftById } = 
    useFetch<DeleteCaseDraftAPIRes>(APIEndpoints.DELETE_CASE_DRAFT)

  useEffect(() => {
    if (deleteCaseDraftRes) {
      const { status, message } = deleteCaseDraftRes
      if (status === 200) {
        showToast([message], ToastTypes.SUCCESS)
        if (draftCaseId === draft.id) {
          reset()
          updateDraftCaseId(0)
        }
        getCaseDraftListing()
      }
      else showToast([message], ToastTypes.WARNING)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteCaseDraftRes])

  const deleteCaseDraft = () => {
    deleteCaseDraftById({}, { draftId: draft.id })
  }





  const populateDraftInCaseForm = () => {
    updateDraftCaseId(draft.id)
    populateCaseDraftInForm(draft)
  }

  const openDeletionConfirmationModal = (event: MouseEvent<HTMLElement, globalThis.MouseEvent>) => {
    setDeletionConfirmationVisibility(true)
    event.stopPropagation()
  }

  return (
      <>
        <li className="list-group-item p-0">
          <a
            className={`btn text-decoration-none d-block ${draftCaseId === draft.id ? "active-draft" : ""}`}
            onClick={populateDraftInCaseForm}
          >
            <span className={"d-block"}>{draft.draft_name.split(",")[0]}</span>
            <small className={"text-muted"}>
              {(() => {
                const raw = draft.draft_name;
                const datePart = raw?.substring(raw.lastIndexOf(",") + 1).trim();

                return datePart.length > 0 && isValid(new Date(datePart))
                  ? format(
                    parse(datePart, "yyyy-MM-dd", new Date()),
                    "MMM dd, yyyy"
                  )
                  : "";
              })()}
            </small>
          </a>
          <i className="bi bi-trash-fill del-btn bg-danger text-white" onClick={openDeletionConfirmationModal}></i>

          <DeletionConfirmationModal
              isModalVisible={showDeletionConfirmationModal}
              removeCurrentData={() => setDeletionConfirmationVisibility(false)}
              restoringCaseData={deleteCaseDraft}
          />
        </li>
      </>
  )
}

export default CaseDraftItem
